import { useEffect, useState } from "react";
import { PageHeader } from "@/components/storefront/PageHeader";
import { Seo } from "@/components/Seo";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Skeleton } from "@/components/ui/skeleton";
import { API } from "@/lib/api";

export default function Faqs() {
  const [items, setItems] = useState(null);

  useEffect(() => {
    API.get("/faqs").then((r) => setItems(r.data)).catch(() => setItems([]));
  }, []);

  return (
    <div data-testid="faqs-page">
      <Seo title="FAQs | Eileen Jenkins Florist" description="Frequently asked questions about ordering, delivery, weddings and funeral tributes." />
      <PageHeader title="Frequently Asked Questions" testId="faqs-header" />
      <div className="max-w-3xl mx-auto px-4 pb-16">
        {items === null ? (
          <div className="space-y-3">{[...Array(5)].map((_, i) => <Skeleton key={i} className="h-14 rounded-lg" />)}</div>
        ) : items.length === 0 ? (
          <p className="text-center text-muted-foreground py-12" data-testid="faqs-empty">No FAQs published yet.</p>
        ) : (
          <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
            {items.map((f) => (
              <AccordionItem key={f.id} value={f.id} data-testid={`faq-${f.id}`}>
                <AccordionTrigger className="text-left font-medium text-base" data-testid={`faq-question-${f.id}`}>{f.question}</AccordionTrigger>
                <AccordionContent className="text-muted-foreground leading-relaxed" data-testid={`faq-answer-${f.id}`}>{f.answer}</AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        )}
      </div>
    </div>
  );
}
